import React, {Dispatch, SetStateAction} from 'react';
import {
  buildDataForChooseFtthClick,
  buildDataForChooseTechnologyClick,
  buildDataForProductClick,
  buildDataForQuestionareModuleDisplay,
  pushToTefDataLayer
} from '@/services/tracking';
import {useSelector} from 'react-redux';
import {
  EcommerceProductValue, ReduxStateType, TariffOfferType, TariffPositionsType,
} from '@/types/av-check';

export interface ButtonBetaProps {
  block?: boolean,
  linkTextContent: string,
  href: string,
  selectedTariff: TariffOfferType,
  highlighted: boolean,
  accessTechs : string,
  clickFunction: React.MouseEventHandler<HTMLAnchorElement>,
  setFtthModelRedirectionState: Dispatch<SetStateAction<boolean>>,
  expansionStatusForFtth: string,
  isCciTheme: boolean
}

const ButtonBeta: React.FC<ButtonBetaProps> = ({
  block,
  linkTextContent,
  href,
  selectedTariff,
  highlighted,
  clickFunction,
  accessTechs,
  setFtthModelRedirectionState,
  expansionStatusForFtth,
  isCciTheme,
}) => {
  const additionalStyleClasses: string[] = [];

  const ecommerceProductValues: EcommerceProductValue[] = useSelector((state: ReduxStateType) => state.result?.ecommerceProductValues) || [];
  const sliderTariffPositions: TariffPositionsType = useSelector((state: ReduxStateType) => state.trackingInfo?.sliderTariffPositions) || {};

  if (block) {
    additionalStyleClasses.push('btn-block');
  }
  const FtthOtherExpansionStatus = expansionStatusForFtth !== 'ready' && expansionStatusForFtth !== 'prepared';
  const isOpenOverlay = href.startsWith('#');
  // eslint-disable-next-line jsx-a11y/control-has-associated-label
  return (
    <a
      className={`btn btn btn-beta ${additionalStyleClasses.join(' ')}`}
      href={href}
      dangerouslySetInnerHTML={{ __html: linkTextContent }}
      data-toggle={ isOpenOverlay ? 'modal' : null}
      data-target={ isOpenOverlay ? href : null}
      onClick={(e) => {
        setFtthModelRedirectionState(false);
        if (href.startsWith('#')) {
          if (href === '#modal-technologieauswahl') {
            pushToTefDataLayer(window, buildDataForChooseTechnologyClick(selectedTariff, accessTechs, highlighted, sliderTariffPositions));
          }
          if (href === '#modal-technologieauswahlftth' && FtthOtherExpansionStatus) {
            if(isCciTheme) {
              document.location.href = selectedTariff.url;
            } else {
              Promise.resolve(pushToTefDataLayer(window, buildDataForChooseFtthClick(selectedTariff, accessTechs, highlighted, sliderTariffPositions)))
                  .then(() => {
                    setTimeout(() => {
                      document.location.href = selectedTariff.url;
                    },1000);
                  }).catch((error) => {
                console.error("Error occur while pushing the tefdatalayer:", error);
              });
            }
          } else if (href === '#modal-technologieauswahlftth') {
            pushToTefDataLayer(window, buildDataForQuestionareModuleDisplay(selectedTariff,sliderTariffPositions));
          }
        } else {
          pushToTefDataLayer(window, buildDataForProductClick(selectedTariff, highlighted, ecommerceProductValues, sliderTariffPositions));
        }
        clickFunction(e);
      }}
    />
  );
};

export default ButtonBeta;
